var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 7.75,
    fill: "url(#paint0_linear_1130_9687)",
    stroke: "#e6e6e6",
    strokeWidth: 0.5,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9998 10.4241L27.4999 14.7098V15C27.4999 15.5907 27.51 16.1853 27.5201 16.7738C27.535 17.6425 27.5496 18.498 27.531 19.3084C27.4993 20.6871 27.3724 22.0225 26.9766 23.2756C26.1698 25.8304 24.283 27.9278 20.1754 29.4682L19.9998 29.534L19.8242 29.4682C15.7166 27.9278 13.8298 25.8304 13.023 23.2756C12.6273 22.0225 12.5004 20.6871 12.4687 19.3084C12.4501 18.4982 12.4647 17.6428 12.4796 16.7742C12.4897 16.1856 12.4998 15.5909 12.4998 15V14.7098L19.9998 10.4241ZM19.9998 11.5758L13.4991 15.2905C13.4966 15.8189 13.4877 16.3303 13.479 16.8296C13.4642 17.6745 13.4501 18.485 13.4685 19.2854C13.474 19.5273 13.4826 19.7654 13.495 20C13.5512 21.065 13.6863 22.055 13.9766 22.9744C14.6593 25.1363 16.2342 27.0144 19.9998 28.4651C23.7653 27.0144 25.3403 25.1363 26.0231 22.9744C26.3134 22.055 26.4485 21.0649 26.5047 20C26.5171 19.7654 26.5257 19.5273 26.5313 19.2854C26.5497 18.4849 26.5355 17.6743 26.5208 16.8292C26.5121 16.33 26.5031 15.8188 26.5006 15.2905L19.9998 11.5758Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.4651C23.7655 27.0144 25.3405 25.1363 26.0233 22.9744C26.3136 22.055 26.4487 21.0649 26.5049 20H20V28.4651Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5759L13.4994 15.2906C13.4968 15.819 13.4879 16.3304 13.4792 16.8297C13.4644 17.6746 13.4503 18.485 13.4687 19.2854C13.4743 19.5273 13.4828 19.7654 13.4952 20H20V11.5759Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1130_9687",
    x1: 1.47849,
    y1: 20,
    x2: 40.0806,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAdminIcon);
export default __webpack_public_path__ + "static/media/DefaultAdminIcon.c315157df40ccd151c536ec2db27bd54.svg";
export { ForwardRef as ReactComponent };